<template>
    <div v-if="modal.backdrop">
        <div
            class="modal fade"
            :class="modal.isOpen ? 'show' : ''"
            tabindex="-1"
            style="display: block"
            role="dialog"
            aria-hidden="true"
            @click="modal.dismiss ? $event.target.classList.contains('modal') ? isModal() : true : true"
        >
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Filter</h5>
                        <button type="button" class="close" v-on:click="isModal" v-html="ic('close')"/>
                    </div>
                    <div class="modal-body pt-3">
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="Mitra" class="form-label">Mitra</label>
                                <selectize
                                    id="Perusahaan"
                                    v-model="filters.id_mitra"
                                    data-placeholder="Pilih Mitra" required>
                                    <option value="" >Tanpa Mitra</option>
                                    <option  
                                        v-for="(mitra, index) in datas.mitras"
                                        :value="mitra.id"
                                        :key="index"> {{mitra.perusahaan}}
                                    </option>
                                </selectize>
                            </div>
                            
                            <div class="form-group col-md-12">
                                <label for="Perusahaan" class="form-label">Perusahaan</label>
                                <selectize
                                    id="Perusahaan"
                                    @input="_getDepo"
                                    v-model="filters.id_perusahaan"
                                    data-placeholder="Pilih Perusahaan" required>
                                    <option  
                                        v-for="(perusahaan, index) in datas.perusahaans"
                                        :value="perusahaan.id"
                                        :key="index"> {{perusahaan.nama_perusahaan}}
                                    </option>
                                </selectize>
                            </div>

                            <div class="form-group col-md-12">
                                <label for="depo" class="form-label">Depo</label>
                                <selectize
                                    id="depo"
                                    :disabled="form.loadingDatas"
                                    v-model="filters.ids_depo"
                                    :settings="form.selectizeConfig"
                                    data-placeholder="Pilih Depo" required>
                                    <option :value="depo.id"  v-for="(depo, index) in datas.depos" :key="index"> {{depo.nama_depo}}</option>
                                </selectize>
                            </div>

                            <div class="form-group col-md-12">
                                <label for="Supervisor" class="form-label">Nama Supervisor</label>
                                <selectize
                                    id="supervisor"
                                    @input="_getTim"
                                    :settings="form.selectizeConfig"
                                    v-model="filters.ids_supervisor"
                                    data-placeholder="Pilih Supervisor">
                                    <option  
                                        :value="supervisor.id"
                                        v-for="(supervisor, index) in datas.supervisors"
                                        :key="index"> {{supervisor.nama_sales_supervisor}}
                                    </option>                                
                                </selectize>
                            </div>

                            <div class="form-group col-md-12">
                                <label for="Salesman" class="form-label">Tim</label>
                                <selectize
                                    id="Tim"
                                    v-model="filters.ids_tim"
                                    :settings="form.selectizeConfig"
                                    data-placeholder="Pilih Tim" required>
                                    <option  
                                        :value="tim.id"
                                        v-for="(tim, index) in datas.tims"
                                        :key="index"> {{tim.nama_tim}}
                                    </option>
                                </selectize>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" @click="isModal" v-html="'Tutup'"></button>
                        <button type="button" :disabled="page.loadingReportData" class="btn btn-primary" @click="_get" v-html="'OK'"></button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState,mapActions } from "vuex";
import helper from "@/assets/js/helper.js"

export default ({
    name: "Modal",
    mixins: [helper],
    data(){
        return{
            datas:{
                perusahaans: [],
                supervisors: [],
                depos: [],
                mitras: [],
                tims: [],
            },
            form: {
                selectizeConfig: {
                    maxItems: 99,
                    plugins: ["remove_button"]
                },
            }
            
        }
    },
    computed: {
        ...mapState("sales_retur",['modal','filters','page']),
    },
    methods: {
        ...mapActions('tim', ['getTimBySpv']),
        ...mapActions('depo', ['getListDepo']),
        ...mapActions("sales_retur",['isModal']),
        ...mapActions('mitra', ['getListMitra']),
        ...mapActions('salesman', ['getListSalesmanSpv']),
        ...mapActions('perusahaan', ['getListPerusahaanByAccess']),
        ...mapActions("sales_retur",['getSalesReturDashboard','getSalesReturReport','isModal']),


        async _get(){
            this.isModal()  
            await this.getSalesReturDashboard()
            await this.getSalesReturReport()
        },

        async _getPerusahaan(){
            try {
                this.datas.perusahaans = await this.getListPerusahaanByAccess({}) 
            } catch (error) {
                console.log(error)
            }
        },
        async _getDepo(){
            let id_perusahaan = this.filters.id_perusahaan
            this.datas.depos = await this.getListDepo({id_perusahaan: id_perusahaan, filter: true})
        },
        async _getSupervisor(){
            try {
                this.datas.supervisors = await this.getListSalesmanSpv({})
            } catch (error) {
                this.datas.supervisors = []
                console.log(error)
            }
        },
        async _getTim(){
            try {
                this.datas.tims = await this.getTimBySpv({ids_supervisor:this.filters.ids_supervisor})
            } catch (error) {
                this.datas.tims = []
                console.log(error)
            }
        },
        async _getMitra(){
            try {
                this.datas.mitras = await this.getListMitra()
            } catch (error) {
                this.datas.tims = []
                console.log(error)
            }
        }


    },
    mounted(){
        if(this.datas.mitras.length == 0) this._getMitra()
        if(this.datas.perusahaans.length == 0) this._getPerusahaan()
        if(this.datas.supervisors.length == 0) this._getSupervisor()
       
    }
})
</script>